
import React from 'react';

const CompanyHeaderSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse mb-6">
      <div className="h-10 bg-slate-200 rounded-md w-1/3 mb-4"></div>
      <div className="h-4 bg-slate-200 rounded-md w-1/4 mb-2"></div>
      <div className="h-4 bg-slate-200 rounded-md w-1/2 mb-4"></div>
      <div className="h-32 bg-slate-200 rounded-md w-full"></div>
    </div>
  );
};

export default CompanyHeaderSkeleton;
